import React from 'react';
import Reflux from 'reflux';
import time from 'time';
import EventViewStore from 'flux/stores/EventViewStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetCueClockStore from 'flux/stores/cuesheet/CuesheetCueClockStore';
import { OverUnderStatuses } from 'shared/flux/stores/cuesheet/CuesheetConstants';
import PermissionStore from 'flux/stores/PermissionStore';
const { OVER, UNDER } = OverUnderStatuses;

export default React.createClass({
  displayName: 'CueOverUnder',

  mixins: [
    Reflux.connect(CuesheetStore, 'cuesheet'),
    Reflux.connectFilter(
      CuesheetCueClockStore,
      'clockReading',
      (clock) => clock.get('reading') || 0,
    ),
    Reflux.connectFilter(
      PermissionStore,
      'hasOverUnderPermission',
      (permissions) => permissions.get('overUnder'),
    ),
    Reflux.connectFilter(EventViewStore, 'twentyFourHour', (event) =>
      event.get('twentyFourHourClock'),
    ),
  ],

  render() {
    const { hasOverUnderPermission } = this.state;

    if (!hasOverUnderPermission) {
      return null;
    }

    return (
      <div className="over-under-clock">
        {this._getOverUnderTimeNode()}
        {this._getStatusNode()}
        {this._getEndTimeNode()}
      </div>
    );
  },

  _getDurationDelta() {
    const { clockReading, cuesheet } = this.state;
    const totalDurationInSeconds = cuesheet.get('totalDurationInSeconds');
    const totalActualDurationInSeconds = cuesheet.get(
      'totalActualDurationInSeconds',
    );

    let durationDelta = totalDurationInSeconds - totalActualDurationInSeconds;
    if (clockReading < 0) durationDelta += clockReading;

    return durationDelta;
  },

  _getStatus() {
    const durationDelta = this._getDurationDelta();
    let status;
    if (durationDelta < 0) {
      status = OVER;
    } else if (durationDelta > 0) {
      status = UNDER;
    }

    return status;
  },

  _getFormattedOverUnderTime() {
    const durationDelta = this._getDurationDelta();

    return time.getFormattedOverUnderDuration(durationDelta);
  },

  _getOverUnderTimeNode() {
    const formattedOverUnderTime = this._getFormattedOverUnderTime();
    const status = this._getStatus() || '';

    const className = `over-under-time ${status}`;

    return <div className={className}>{formattedOverUnderTime}</div>;
  },

  _getStatusNode() {
    const status = this._getStatus();

    const overClassName = status === OVER ? OVER : '';
    const underClassName = status === UNDER ? UNDER : '';

    return (
      <div className="over-under-status">
        <span className={overClassName}>Over</span>
        <span> / </span>
        <span className={underClassName}>Under</span>
      </div>
    );
  },

  _getEndTimeNode() {
    const { clockReading, cuesheet } = this.state;

    const twentyFourHour = cuesheet.get('twentyFourHour');
    const rows = cuesheet.get('rows');
    if (!rows) return null;
    const finalRowPath = cuesheet.get('rows').last().get('path');
    const finalRow = cuesheet.get('rowMap').getIn(finalRowPath);
    let totalActualDurationInSeconds = cuesheet.get(
      'totalActualDurationInSeconds',
    );
    let totalDurationInSeconds = cuesheet.get('totalDurationInSeconds');

    if (clockReading < 0) totalActualDurationInSeconds += -clockReading;

    const finalRowOffset =
      finalRow.get('durationInSeconds') +
      totalActualDurationInSeconds -
      totalDurationInSeconds;

    const showEndOn = finalRow.get('startOnAdjusted') + finalRowOffset * 1000;
    const formattedShowEnd = time.getFormattedUTCTimeWithSeconds(
      showEndOn,
      twentyFourHour,
    );

    if (!formattedShowEnd) return null;

    const message = `Ending at ${formattedShowEnd}`;

    return <div className="over-under-ending">{message}</div>;
  },
});
